import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ViedocDialogElement,
  ViedocButtonElement,
} from "../../../../secure/elements/ViedocReactElements";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import * as templateActions from "../../../../store/actions/templateActions";
import { useDispatch, useSelector } from "react-redux";
import APP_CONST from "../../../shared/constants";

const ManageTemplatePopUp = ({
  templateInfo,
  setIsManageTemplateVisible,
  setDeletingTemplateId,
  setEditingTemplateId,
  setIsDeletePopUpVisible,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { tmfStructureData } = useSelector((store) => store.template);
  const { originaltemplateid, status } = tmfStructureData;

  const [isEditable, setIsEditable] = useState(false);
  const [templateName, setTemplateName] = useState(
    UtilsHelper.fileExtensionRemoval(templateInfo.templatename)
  );
  const [isTempalteNameChanged, setIsTemplateNameChanged] = useState(false);
  const fileType = UtilsHelper.getFileExtension(templateInfo.templatename);

  const spanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };

  const onHide = () => {
    setIsManageTemplateVisible(false);
    setIsEditable(false);
  };

  const templateNameEditHandler = (event) => {
    setTemplateName(event.target.value);
    event.target.value !==
    UtilsHelper.fileExtensionRemoval(templateInfo.templatename)
      ? setIsTemplateNameChanged(true)
      : setIsTemplateNameChanged(false);
  };

  const deleteTemplateHandler = () => {
    setIsDeletePopUpVisible(true);
    setDeletingTemplateId(templateInfo.templateid);
    setEditingTemplateId();
    document.getElementById("manage-template-view")?.hide();
  };

  const saveChangesHandler = () => {
    setEditingTemplateId(templateInfo.templateid);
    const renamePayload = {
      templateId: templateInfo.templateid,
      templateName: templateName.concat(`.${fileType}`),
    };

    dispatch(
      templateActions.renameTemplate(
        renamePayload,
        templateInfo.templatecategory,
        templateInfo.isSelected
      )
    );
    setDeletingTemplateId();
    document.getElementById("manage-template-view")?.hide();
  };

  return (
    <ViedocDialogElement
      id="manage-template-view"
      size="small"
      open
      preventCloseByClick
      onHide={() => onHide()}
    >
      <header className="d-flex jc-center" slot="header">
        <p className="pl-10 pt-8 f21">{t("ADMIN.TEMPLATES_MANAGETEMPLATE")}</p>
        <div className="template-header-button">
          {!isEditable && (
            <ViedocButtonElement
              size="small"
              onClick={() => setIsEditable(true)}
              title={t("ADMIN.TEXT_EDIT")}
            >
              {t("ADMIN.TEXT_EDIT")}
            </ViedocButtonElement>
          )}
          {isTempalteNameChanged && templateName !== "" && (
            <ViedocButtonElement
              size="small"
              onClick={() => saveChangesHandler()}
              title={t("ADMIN.BUTTON_SAVECHANGEBTN")}
            >
              {t("ADMIN.BUTTON_SAVECHANGEBTN")}
            </ViedocButtonElement>
          )}
        </div>
      </header>
      <main>
        <form className="template-form pt-20 pb-20">
          <p className="f14 mb-10">
            {t("ADMIN.TEMPLATES_NAME")}
            {spanFunc()}
          </p>
          <viedoc-textfield
            class="template_input"
            size="small"
            variant="outline"
          >
            <input
              type="text"
              disabled={!isEditable}
              className={isEditable ? "color-black" : "disabled-input-field"}
              value={templateName}
              onChange={(e) => templateNameEditHandler(e)}
            />
          </viedoc-textfield>
          <p className="f14 mb-10 mt-25">
            {t("ADMIN.TEMPLATES_CATEGORY")}
            {spanFunc()}
          </p>
          <viedoc-textfield
            class="template_input"
            size="small"
            variant="outline"
          >
            <input
              type="text"
              disabled
              className="disabled-input-field"
              value={templateInfo.templatecategory}
            />
          </viedoc-textfield>
          <div className="pb-5"></div>
        </form>
      </main>

      <footer slot="footer" className="template-footer">
        <div
          className="d-flex align-center jc-center gap-8"
          style={{ flexDirection: "column" }}
        >
          <ViedocButtonElement
            variant="error"
            onClick={() => deleteTemplateHandler()}
            size="small"
            disabled={
              status === APP_CONST.ADMIN_TEMPLATE_STATUS[1] &&
              originaltemplateid === templateInfo.templateid
            }
            title={t("ADMIN.TEMPLATES_DELETETEMPLATE")}
          >
            <viedoc-icon
              name="delete_bin"
              slot="prefix"
              class="delete-template"
            ></viedoc-icon>
            {t("ADMIN.TEMPLATES_DELETETEMPLATE")}
          </ViedocButtonElement>
          {status === APP_CONST.ADMIN_TEMPLATE_STATUS[1] &&
            originaltemplateid === templateInfo.templateid && (
              <p className="f12 gray-60">{t("ADMIN.TEMPLATES_TEMPLATEMSG")}</p>
            )}
        </div>
      </footer>
    </ViedocDialogElement>
  );
};

export default ManageTemplatePopUp;
